import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=2a68ca18&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=2a68ca18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68ca18",
  null
  
)

export default component.exports